import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    printBtn: {
        position: 'fixed',
        bottom: 24,
        right: 24,
        borderRadius: '10px',
        fontSize: '1rem',
        fontWeight: 600,
        zIndex: 1000,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        '@media print': {
            display: 'none',
        },
    },
    
    dataCard: {
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        borderRadius: theme.spacing(1),
        backgroundColor: '#f8f9fa',
    },
    
    stepCard: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(3),
        borderRadius: theme.spacing(1),
        pageBreakInside: 'avoid',
    },
    
    taskStep: {
        borderLeft: '4px solid #1976d2',
        backgroundColor: '#f8f9fa',
    },
    
    formStep: {
        borderLeft: '4px solid #f57c00', 
        backgroundColor: '#fff8e1',
    },
    
    statisticsCard: {
        padding: theme.spacing(3),
        textAlign: 'center',
        borderRadius: theme.spacing(1),
    },
    
    header: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        padding: theme.spacing(4),
        marginBottom: theme.spacing(4),
        borderRadius: theme.spacing(1),
    }
}));
